/* eslint-disable */
import FaqApiClient from "../api/FAQApi";
import ApplicationStore from "./ApplicationStore";

class RootStore {
    applicationStore:ApplicationStore;
    constructor(applicationApi: FaqApiClient) {
        this.applicationStore = new ApplicationStore(applicationApi);
    }
}

export default RootStore